import Vue from "vue";

export const store = Vue.observable({
    is_cantidad_procesos: true,
    fuentes: [],
    actividadesPrincipales: [],
    totalProcesos: 0,
    totalDinero: 0,
    levelProcesos: 0,
    levelDinero: 0,
    filtrosFuentes: [],
    filtrosActividades: [],
    listadoDepartamentos: [],
    dataActividades: [],
    dataDepartamentos: [],
    deptoSelected: null,
    allFilterChecked: false,
    sinData: false,
});

export const mutations = {
    /**
     * Determina si todos los filtros se deben chequear
     * 
     * @param { Bool } checked
     * 
     * @author Óscar
     */
    checkAllFilters (checked = true) {
        store.allFilterChecked = checked;
    },
    /**
     * @description Funcion para agregar todas las fuentes
     * @param {*} val Arreglo de fuente
     * @author Daniel Sanchez
     */
    addFuentes(val) {
        if (! Array.isArray(val)) {
            val = [val];
        }
        store.fuentes.push(...val);
    },
    /**
     * @description Funcion para agregar filtros de las fuentes
     * @param {*} val id de filtro
     * @author Daniel Sanchez
     */
    addFiltrosFuentes(val) {
        store.filtrosFuentes.push(val);
    },
    /**
     * @description Funcion para limpiar losfiltros de las fuentes
     * @author Daniel Sanchez
     */
    clearFiltrosFuentes() {
        store.filtrosFuentes = []
    },
    /**
     * @description Funcion para agregar todas las actividades
     * @param {*} val Arreglo de actividades
     * @author Daniel Sanchez
     */
    addActividades(val) {
        if (! Array.isArray(val)) {
            val = [val];
        }
        store.actividadesPrincipales.push(...val);
    },
    /**
     * @description Funcion para agregar filtros de las actividades
     * @param {*} val id de actividad
     * @author Daniel Sanchez
     */
    addFiltrosActividades(val) {
        store.filtrosActividades.push(val);
    },
    /**
     * @description Funcion para limpiar los filtros de las actividades
     * @author Daniel Sanchez
     */
    clearFiltrosActividades() {
        store.filtrosActividades = []
    },
    /**
     * @description Funcion para agregar la data del listado de departamentos
     * @param {*} val
     * @author Óscar
     */
    addListadoDepartamentos(val) {
        if (! Array.isArray(val)) {
            val = [val];
        }
        store.listadoDepartamentos.push(...val);
    },
    /**
     * @description Funcion para agregar la data de las actividades económicas
     * @param {*} val
     * @author Óscar
     */
    addDataActividades(val) {
        if (! Array.isArray(val)) {
            val = [val];
        }
        store.dataActividades.push(...val);
    },
    /**
     * Limpia el arreglo de la data de las actividades económicas
     * 
     * @author Óscar
     */
    clearDataActividades () {
        store.dataActividades = [];
    },
    /**
     * @description Funcion para agregar la data de los departamentos
     * @param {*} val
     * @author Óscar
     */
    addDataDepartamentos(val) {
        if (! Array.isArray(val)) {
            val = [val];
        }
        store.dataDepartamentos.push(...val);
    },
    /**
     * Actualiza la data de los deptos con el depto a actualizar
     * 
     * @param { Int } idUpdateDepto
     * @param { Array } updateDeptoObj
     * 
     * @author Óscar
     */
    updateASingleDepto (idUpdateDepto, [ updateDeptoObj ]) {
        if (store.dataDepartamentos?.length) {
            const foundIdx = store.dataDepartamentos.findIndex(({ id_departamento: id }) => id === idUpdateDepto);
            if (foundIdx >= 0) {
                let copyDataDepartamentos = [...store.dataDepartamentos];
                let { fuentes = null, total_procesos = null, total_cuantia = null } = updateDeptoObj || {};

                copyDataDepartamentos[foundIdx] = Object.assign({}, store.dataDepartamentos[foundIdx], { fuentes, total_procesos, total_cuantia });
                store.dataDepartamentos = copyDataDepartamentos;
            }
        }
    },
    /**
     * Limpia el arreglo de la data de los departamentos
     * 
     * @author Óscar
     */
    clearDataDepartamentos () {
        store.dataDepartamentos = [];
    },
    /**
     * Cambia la selección de filtros para la fuente
     * 
     * @author Óscar
     */
    changeFuenteFilers (change) {
        store.filtrosFuentes = change;
    },
    /**
     * Cambia la selección de filtros para las actividades económicas
     * 
     * @author Óscar
     */
    changeActividadesFilter (change) {
        store.filtrosActividades = change;
    },
    /**
     * Funcion para realizar el cambio de treemap de procesos a dinero o viceversa
     * @author Daniel Sanchez
     */
    changeTreemap() {
        store.is_cantidad_procesos ? store.is_cantidad_procesos = (!store.is_cantidad_procesos) : store.is_cantidad_procesos = true;
    },
   /**
    * Muta el departamento/provincia seleccionado
    * 
    * @param { Object } depto
    * 
    * @author Óscar
    */
    changeDeptoSelected (depto) {
        store.deptoSelected = depto;
    },
   /**
    * Remueve el departamento/provincia seleccionado
    * 
    * @param { Object } depto
    * 
    * @author Óscar
    */
    removeDeptoSelected () {
        this.changeDeptoSelected(null);
    },
    /**
     * Cambia el total de procesos
     * @author Daniel Sanchez
     */
    changeTotalProcesos (change) {
        store.totalProcesos = change;
    },
    /**
     * Cambia el valor total de procesos del nivel al que se ingresa
     * @author Daniel Sanchez
     */
    changeTotalLevelProcesos (change) {
        store.levelProcesos = change;
    },
    /**
     * Cambia el total de cuantia
     * @author Daniel Sanchez
     */
    changeTotalCuantia (change) {
        store.totalDinero = change;
    },
    /**
     * Cambia el valor total de cuantia del nivel al que se ingresa
     * @author Daniel Sanchez
     */
    changeTotalLevelCuantia (change) {
        store.levelDinero = change;
    },
    /**
     * Realiza el cambio de la variable que determina si la consulta trae data o no y reinicia los contadores
     * @author Daniel Sanchez
     */
    updateSinData(value) {
        store.sinData = value
        if (value) {
            mutations.changeTotalProcesos(0)
            mutations.changeTotalCuantia(0)
        }
    }
}